import { useQuery } from '@change-corgi/core-react/async';
import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import type { PetitionUpdatesQueryState, QueryState } from '#src/app/pages/petitionDetails/shared/types';

import { getPetitionUpdates } from './getPetitionUpdates';

export function usePetitionUpdatesQuery(queryState: QueryState): PetitionUpdatesQueryState {
	const {
		data: {
			petition: { id },
		},
	} = usePetitionDetailsPageData();

	const utilityContext = useUtilityContext();

	return useQuery(async () => getPetitionUpdates(id, queryState, utilityContext), [id, utilityContext, queryState]);
}
